import React, { useContext } from "react";
import Style from "./q&a.module.scss";
import Box from "@mui/material/Box";
import {
  SearchTextInput,
  MultipleSelect,
  TextEditor,
} from "../../../../../components";
import { DiscussItem } from "../../../index";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { authGetPaginate, authGetRequest } from "../../../../../api/laravel/public/api";
import { errorMessage } from "../../../../../utils/notification";
import { toast } from "react-toastify";
import {
  ArrowBack,
  ArrowUpwardOutlined,
  ChevronLeft,
  Delete,
  Edit,
  Reply,
} from "@mui/icons-material";
import moment from "moment";
import Comment from "./layout/comment";
import { updateStateArray } from "../../../../../utils/map";
import ReplyComponent from "./layout/reply";
import { AuthContext } from "../../../../../context/auth/ApiContext";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
// import RichTextEditor from 'react-rte';

function QandA(props) {
  const { discussion, index, type, submitComment, submitCommentMore } = props;
  const { user } = useContext(AuthContext);
  const [data, setData] = React.useState({});
  const [commentCount, setCommentCount] = React.useState(0);
  const [reply, setReply] = React.useState([]);
  const [tab, setTab] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [isLoadmore, setLoadMore] = React.useState(false);
  const [input, setInput] = React.useState({ description: null });
  const [comment, setComment] = React.useState([]);
  const [next_url, setNextUrl] = React.useState(null);
  const [comment_id, setCommentId] = React.useState(null);


  const handleInputs = (label, e) => {
    var val = e;
    setInput({ ...input, [label]: val });
  };

  React.useEffect(() => {
    showComment();
    setLoading(false)
  }, [index]);


  const getDiscussion = async () => {
    setLoading(true);
    const { data_r, isError } = await authGetRequest(
      `/account/dashboard/discussions/${discussion}`
    );
    if (isError) {
      errorMessage(toast, data_r?.message);
      setLoading(false);
      return false;
    }
    setData(data_r);
    setLoading(false);
  };

  const deleteComment = async (id) => {
    setLoading(true);
    const { data_r, message, isError, isLoading } = await authGetRequest(
      `/account/dashboard/delete/comment/${id}`
    );
    setComment(data_r?.comment?.data);
    setNextUrl(data_r?.comment?.next_page_url);
    setLoading(false);
  }

  const showComment = async () => {
    if (discussion) {
      setComment([]);
      const { data_r, isError, isLoading } = await authGetRequest(
        "/account/dashboard/discussions/view/" + discussion
      );
      setComment(data_r?.comment?.data);
      setNextUrl(data_r?.comment?.next_page_url)
      setCommentCount(data_r?.total_comment);
    }
  };

  const loadMore = async (url) => {
    setLoadMore(true);
    const { data_r, isError, isLoading } = await authGetPaginate(
      url
    );
    if (data_r?.comment) {
      await updateStateArray(comment, data_r?.comment?.data, setComment);
      setNextUrl(data_r?.comment?.next_page_url)
    }
    setLoadMore(false);
  }

  const submitDiscussion = async () => {
    setLoading(true);
    let resp = await submitComment(input);
    await showComment();
    setInput({ description: null })
    setLoading(false);
  };

  // const showCommentMore = async (ev) => {
  //   setTab(1);
  //   const { data_r, isError, isLoading } = await authGetRequest(
  //     "/account/dashboard/discussions-comment/view/" + ev
  //   );
  //   setSubData(data_r);
  //   setReply(data_r?.comments_more);
  //   setCommentId(ev);
  // }


  const submitDiscussionComment = async () => {
    setLoading(true);
    input['comment_ref'] = comment_id;
    let resp = await submitCommentMore(input);
    await showComment();
    setLoading(false);
  }

  // const onDelete = (id) => {
  //   confirmAlert({
  //     title: 'Confirm to delete',
  //     message: 'Are you sure to do this.',
  //     buttons: [
  //       {
  //         label: 'Yes',
  //         onClick: async () => {
  //           let resp = await deleteComment(id);
  //           setReply(resp?.comment);
  //           if (resp?.back) {
  //             setTab(0);
  //             showComment();
  //           }
  //         }
  //       },
  //       {
  //         label: 'No',
  //         onClick: () => console.log('Click No')
  //       }
  //     ]
  //   });
  // }

  return (
    <div className="inner">
      <h3 className="md black">{commentCount} Comments</h3>
      {type === "discussion" &&
        <div className="form-discussion">
          {/* <div className="text-title">
          <input type="text" placeholder="Topic title here" />
        </div> */}
          <div className="post-editor text-form-editor">
            <img src={"images/editor-demo-1.jpg"} alt="" />
            <textarea placeholder="Discussion content" value={input['description']} onChange={(e) => handleInputs("description", e.target.value)} defaultValue={""} />
          </div>
          <div className="form-submit">
            <button
              onClick={submitDiscussion}
              disabled={loading}
              className="mc-btn-2 btn-style-2">
              {loading && (
                <div
                  id="comment_loader_spinner"
                  className="spinner-border spinner-border-sm text-default"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              {!loading && (
                <b id="comment_button">
                  <i className="bx bx-comment"></i>Discuss
                </b>
              )}
            </button>
          </div>
        </div>}
      <ul className="list-discussion">
        {/* LIST ITEM */}
        {comment?.map((item, index) => (
          <li>
            <div className="list-body">
              <div className="image">
                {item?.created_by?.image &&
                  <img
                    width={30}
                    src={
                      process.env.REACT_APP_LOCAL_FILE_PATH +
                      "profile/small/" +
                      item?.created_by?.image
                    }
                    loading="lazy"
                  />}
                {!item?.created_by?.image &&
                  <div style={{ height: 40 }} className="btn btn-success rounded p-2">
                    {item?.created_by?.first_name.charAt(0)}{item?.created_by?.last_name.charAt(0)}
                  </div>
                }
              </div>
              <div className="list-content">

                <cite className="xsm black bold"><a >{item?.created_by?.first_name} {item?.created_by?.last_name}</a></cite>
                <h4 className="discuss_comment black" dangerouslySetInnerHTML={{ __html: item?.description }}></h4>
                <div className="comment-meta">
                  <a >{moment(item?.created_at).fromNow()}</a>
                  {/* <a href="#"><i className="icon md-arrow-up" />13</a>
                  <a href="#"><i className="icon md-arrow-down" />25</a>
                  <a href><i className="icon md-back" />384 replies</a> */}
                </div>
              </div>
            </div>
          </li>
        ))}
        {/* END / LIST ITEM */}
        <div className="load-more">
          {next_url && (
            <a
              disabled={isLoadmore}
              onClick={() => loadMore(next_url)}
              className={"cursor-pointer"}
            >
              {isLoadmore &&
                <div
                  id="comment_loader_spinner"
                  className="spinner-border spinner-border-sm text-default"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>}
              {!isLoadmore &&
                <span className="text-base text-lg">See More</span>}
            </a>
          )}
        </div>
      </ul>
    </div>
  );
}

export default QandA;
